import { Input } from "../../ui/Input";
export const AdminUSerForm = ({formData}) => {
    return (
        <div className="transaction-form">
        
        <Input
                label="Username"
                type="text"
                name="Username"
                value={formData.Username}
                disabled={true}
              />
              <Input
                label="Email Address"
                type="text"
                name="EmailAddress"
                value={formData.EmailAddress}
                disabled={true}
              />
              
        </div>
    )
}